// ElectionsPage.js
import React from 'react';

import UpcomingElections from './UpcomingElections';

/**
 * ElectionsPage
 *
 * The Elections tab in the bottom bar, at /us/elections-dashboard: the
 * reader's next election, the parties on their ballot and who is running,
 * as a page of its own. /us/elections stays the Elections topic of the
 * Federal feed.
 *
 * UpcomingElections lays itself out: 15px sides on a phone, a centered 700px
 * column on desktop. This page adds breathing room above and below it, and
 * drops the panel's own card surface so the candidate cards sit on the page
 * background, as the spending dashboard's cards do.
 * The top bar titles the page "Elections" (IntegratedSearchNavBar).
 */
function ElectionsPage() {
  return (
    <div className="standalone-panel-page elections-page">
      <UpcomingElections />

      <style>{`
        .standalone-panel-page {
          padding-top: 8px;
          padding-bottom: 24px;
        }

        /* The panel's own surface (a rounded --navbar-pill-bg card with inner
           padding) was built for sitting above a feed, where it set the
           elections apart from the posts under it. As the whole page it drew a
           second white box behind the candidate cards, which are cards of
           their own. Here the cards sit straight on the page background, the
           way the spending dashboard's do. The panel's width (15px sides on a
           phone, the centered 700px column on desktop) is kept. */
        .elections-page .upcoming-elections {
          background: transparent;
          border-radius: 0;
          box-shadow: none;
          padding-left: 0;
          padding-right: 0;
        }
      `}</style>
    </div>
  );
}

export default ElectionsPage;